import { ValueOf } from '../lib/interfaces/utils';

export type SortOrderValue = ValueOf<typeof SortOrder>;

export enum SortOrder {
	DESC = 'desc',
	ASC = 'asc',
}

export type Sort<T extends string = string> = {
	field: T;
	value: SortOrderValue;
};
